import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../../3rdPartyModules/_react-aria/focus/dist/import-5c0d2803.js';
import { f as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../../3rdPartyModules/_react-aria/utils/dist/import-d09f487d.js';
import { f as focusOutlineMixin } from '../../FocusIndicator/styleMixins/focusOutline-ae6f4c7f.js';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-701df069.js';
import { d as defaultContextValue, a as RadioGroupContext } from '../RadioGroupContext-3d993c24.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-189dc982.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-12ae0974.js';
import { a as RadioButtonContainer } from '../RadioButtonGroup/RadioButtonGroup-872c9154.js';

const NodeSafeHTMLInputElement = typeof HTMLInputElement !== 'undefined' ? HTMLInputElement : Object;
const StyledInput = /*#__PURE__*/styled('input').attrs(props => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(props, focusProps),
    $focusVisible: isFocusVisible
  };
}).withConfig({
  componentId: "sc-storm-ui-30039493__sc-1yio0qi-0"
})(["&&&{-webkit-appearance:none;position:relative;flex:0 0 auto;background-color:", ";width:", ";height:", ";margin:0;margin-top:1px;margin-inline-end:", ";transition:none;border-radius:100%;border:1px solid ", ";@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease,box-shadow 100ms ease;}::before{content:'';display:block;position:absolute;top:50%;left:50%;/*! @noflip */ transform:translateY(-50%) translateX(-50%);width:", ";height:", ";background-color:", ";border-radius:100%;}:hover{cursor:", ";border-color:", ";box-shadow:none;background-color:", ";}:active{transform:scale(1.2);background-color:", ";box-shadow:none;}:focus{outline:none;", ";}:disabled{cursor:not-allowed;opacity:0.5;outline:none;:active{transform:none;}:hover{background-color:", ";border-color:", ";box-shadow:none;:checked{background-color:", ";border:1px solid ", ";}}}", " vertical-align:auto;bottom:auto;}"], ({
  checked,
  theme
}) => checked ? theme.form.radio.bgChecked : theme.form.radio.bg, ({
  theme
}) => theme.form.radio.inputWidth, ({
  theme
}) => theme.form.radio.inputHeight, ({
  theme
}) => theme.form.radio.marginInlineEnd, ({
  checked,
  theme
}) => checked ? theme.form.radio.borderColorChecked : theme.form.radio.borderColor, ({
  theme
}) => theme.form.radio.inputDotWidth, ({
  theme
}) => theme.form.radio.inputDotHeight, ({
  checked,
  theme
}) => checked ? theme.form.radio.activeColor : theme.form.radio.bg, ({
  disabled
}) => disabled ? 'not-allowed' : 'pointer', ({
  theme
}) => theme.focusVisible.borderColor, ({
  checked,
  theme
}) => checked ? theme.form.radio.bgActive : theme.form.radio.bgHover, ({
  checked,
  theme
}) => checked ? theme.form.radio.bgActive : theme.form.radio.bgHover, ({
  $focusVisible
}) => $focusVisible && focusOutlineMixin, ({
  theme
}) => theme.form.radio.bg, ({
  theme
}) => theme.form.radio.borderColor, ({
  theme
}) => theme.form.radio.bgChecked, ({
  theme
}) => theme.form.radio.borderColorChecked, isMobile(css(["top:1px;"])));
const WrapperLabel = /*#__PURE__*/styled('label').withConfig({
  componentId: "sc-storm-ui-30039493__sc-1yio0qi-1"
})(["cursor:", ";color:", ";font-size:", ";display:flex;flex-direction:row;padding:", ";align-items:", ";margin-bottom:", ";margin-inline-end:", ";margin-inline-start:0;", " ", " box-sizing:border-box;"], ({
  disabled
}) => disabled ? 'not-allowed' : 'pointer', ({
  disabled,
  theme
}) => disabled ? theme.form.label.colorDisabled : theme.form.label.color, ({
  theme
}) => theme.form.radio.buttonFontSize, ({
  theme
}) => theme.form.radio.buttonPadding, ({
  inline
}) => inline ? 'center' : 'flex-start', ({
  inline,
  theme
}) => inline ? 0 : theme.spacing.micro, ({
  inline,
  theme
}) => inline ? theme.spacing.base : 0, isMobile(css(["margin-inline-end:0;margin-inline-start:0;"])), isMobile(css(["align-items:flex-start;border:", " solid ", ";border-radius:", ";font-size:", ";margin-bottom:0;padding:", ";", " &&{background-color:", ";border:none;border-radius:0;border-bottom:", " solid ", ";}", " &&:first-of-type{border-radius:", " ", " 0 0;}", " &&:last-of-type{border-radius:0 0 ", " ", ";border-bottom:none;}"], ({
  theme
}) => theme.form.radio.mobile.buttonBorderWidth, ({
  theme
}) => theme.form.radio.mobile.buttonBorderColor, ({
  theme
}) => theme.form.radio.mobile.buttonBorderRadius, ({
  theme
}) => theme.form.radio.mobile.buttonFontSize, ({
  theme
}) => theme.form.radio.mobile.buttonPadding, RadioButtonContainer, ({
  theme
}) => theme.form.radio.mobile.backgroundColor, ({
  theme
}) => theme.form.radio.mobile.buttonBorderWidth, ({
  theme
}) => theme.form.radio.mobile.buttonBorderColor, RadioButtonContainer, ({
  theme
}) => theme.form.radio.mobile.buttonBorderRadius, ({
  theme
}) => theme.form.radio.mobile.buttonBorderRadius, RadioButtonContainer, ({
  theme
}) => theme.form.radio.mobile.buttonBorderRadius, ({
  theme
}) => theme.form.radio.mobile.buttonBorderRadius)));
WrapperLabel.displayName = 'Wrapper';
const StyledLabelText = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30039493__sc-1yio0qi-2"
})(["", ";flex:1 1 auto;", ""], ({
  theme
}) => theme.typography.base, isMobile(css(["", ";"], ({
  theme
}) => theme.typography.mobile.base)));
StyledLabelText.displayName = 'StyledLabel';
class RadioButton extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "context", defaultContextValue);
    _defineProperty(this, "handleChange", event => {
      const {
        onChange
      } = this.props;
      const {
        handleRadioChange
      } = this.context;
      handleRadioChange === null || handleRadioChange === void 0 || handleRadioChange(event);
      onChange === null || onChange === void 0 || onChange(event);
    });
  }
  render() {
    const {
      id,
      disabled,
      inline,
      isChecked,
      inputRef,
      label,
      onChange,
      value,
      taktId,
      taktValue,
      ...rest
    } = this.props;
    const {
      name,
      isGroupDisabled,
      isGroupInline,
      selectedValue
    } = this.context;
    const radioId = this.context ? `${name}-${value}` : id;
    const checked = selectedValue ? selectedValue === value : isChecked;
    return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
      taktId: taktId,
      fallbackId: createStormTaktId('radio-button')
    }, ({
      getDataTaktAttributes
    }) => /*#__PURE__*/React__default.createElement(WrapperLabel, _extends({
      disabled: isGroupDisabled || disabled,
      inline: isGroupInline,
      htmlFor: radioId
    }, getDataTaktAttributes({
      taktValue,
      taktIdSuffix: 'label'
    })), /*#__PURE__*/React__default.createElement(StyledInput, _extends({}, getDataTaktAttributes({
      taktValue,
      contextOnlyTaktValues: {
        value,
        checked
      }
    }), rest, {
      type: "radio",
      id: radioId,
      name: name,
      checked: checked,
      onChange: this.handleChange,
      value: value,
      disabled: isGroupDisabled || disabled,
      ref: inputRef
    })), /*#__PURE__*/React__default.createElement(StyledLabelText, null, label)));
  }
}
_defineProperty(RadioButton, "propTypes", {
  /* managed by RadioGroup */
  id: PT.string.isRequired,
  /**
   * Positions the Label inline with the control.
   */
  inline: PT.bool,
  /**
   * Signifies whether the <RadioButton> has been selected.
   */
  isChecked: PT.bool,
  /**
   * Callback that is called when the <RadioButton> is selected.
   */
  onChange: PT.func,
  /**
   * Unique name for the <RadioButton>.
   */
  name: PT.string,
  /**
   * Use this to access the ref for the underlying <input>.
   */
  inputRef: PT.shape({
    current: PT.instanceOf(NodeSafeHTMLInputElement)
  }),
  /**
   * The label that describes the <RadioButton>.
   */
  label: PT.node,
  /**
   * The unique value of the <RadioButton> choice.
   */
  value: PT.string.isRequired,
  /**
   * Disables the <RadioButton>.
   */
  disabled: PT.bool
});
_defineProperty(RadioButton, "defaultProps", {
  inputRef: undefined,
  label: undefined,
  inline: false,
  isChecked: undefined,
  onChange: undefined,
  name: undefined,
  disabled: false
});
_defineProperty(RadioButton, "contextType", RadioGroupContext);

export { RadioButton as R };
//# sourceMappingURL=RadioButton-0cb296f1.js.map
